import React from "react";

const Spacer = () => {
    return <div className="my-md-5 py-5"></div>;
};

export default Spacer;